import React, { useState, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import content from "../content";

// ============ Photos =============
// Photos de l'utilisateur + photos de l'ancien site Wix
const PHOTOS = [
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/ltyr5g97_MACRO%202.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/ltyr5g97_MACRO%202.jpg",
        alt: "Plat - Macro",
        caption: "Création du chef",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/p95mtv5m_salle%20la%20table%20d%27albigny%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/p95mtv5m_salle%20la%20table%20d%27albigny%20la%20table%20d%27albigny.jpg",
        alt: "Salle du restaurant — vaisselier ancien",
        caption: "Salle de caractère",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/qn3wc9r7_ST%20JACQUES.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/qn3wc9r7_ST%20JACQUES.jpg",
        alt: "Saint-Jacques",
        caption: "Saint-Jacques",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/83m1wwfk_cocktail%20verrine%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/83m1wwfk_cocktail%20verrine%20la%20table%20d%27albigny.jpg",
        alt: "Cocktail en verrine",
        caption: "Verrine d'apéritif",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/nkalbihv_truite%20sushi%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/nkalbihv_truite%20sushi%20la%20table%20d%27albigny.jpg",
        alt: "Truite façon sushi",
        caption: "Truite façon sushi",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/ufp5lej8_VITELLO%20TONNATO.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/ufp5lej8_VITELLO%20TONNATO.jpg",
        alt: "Vitello Tonnato",
        caption: "Vitello Tonnato",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/41lfviug_AMUSES%20BOUCHES.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/41lfviug_AMUSES%20BOUCHES.jpg",
        alt: "Amuses bouches",
        caption: "Amuses-bouches",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/fw7w6whq_vaisselier%20sallle%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/fw7w6whq_vaisselier%20sallle%20la%20table%20d%27albigny.jpg",
        alt: "Salle du restaurant",
        caption: "Une ambiance chaleureuse",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/7e4vqptn_cocktail%20dinatoire%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/7e4vqptn_cocktail%20dinatoire%20la%20table%20d%27albigny.jpg",
        alt: "Cocktail dînatoire",
        caption: "Cocktail dînatoire",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/6dzjydrq_AGNEAU%20CONFIT.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/6dzjydrq_AGNEAU%20CONFIT.jpg",
        alt: "Agneau confit",
        caption: "Agneau confit",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/0njg5rqo_table%20ronde%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/0njg5rqo_table%20ronde%20la%20table%20d%27albigny.jpg",
        alt: "Table dressée et lanterne",
        caption: "Table dressée",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/bwicagy4_BEURRE%20CACAHUETE.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/bwicagy4_BEURRE%20CACAHUETE.jpg",
        alt: "Dessert beurre de cacahuète",
        caption: "Tartelette chocolat-cacahuète",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/cwvgr3c0_fromage%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/cwvgr3c0_fromage%20la%20table%20d%27albigny.jpg",
        alt: "Plateau de fromages",
        caption: "Plateau de fromages",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/hdmogdvu_ABRICOT.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/hdmogdvu_ABRICOT.jpg",
        alt: "Dessert abricot",
        caption: "Abricots & amandes",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/mfhwunm3_salle%20table%20la%20table%20d%27albigny%281%29.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/mfhwunm3_salle%20table%20la%20table%20d%27albigny%281%29.jpg",
        alt: "Carte des vins de France",
        caption: "Carte des vins de France",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/abax8oi4_ACRAS.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/abax8oi4_ACRAS.jpg",
        alt: "Acras",
        caption: "Acras croustillants",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/17ls2o4x_Supr%C3%AAmes%20de%20pintade.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/17ls2o4x_Supr%C3%AAmes%20de%20pintade.jpg",
        alt: "Suprêmes de pintade",
        caption: "Suprêmes de pintade",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/50et0cr7_PAINS.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/50et0cr7_PAINS.jpg",
        alt: "Pains maison",
        caption: "Pains de notre boulanger Zymo",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/q7p00oa1_bar%20cave%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/q7p00oa1_bar%20cave%20la%20table%20d%27albigny.jpg",
        alt: "Bar et cave du restaurant",
        caption: "Ambiance...",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/676div6r_bar%20cave%20la%20table%20d%27albigny%281%29.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/676div6r_bar%20cave%20la%20table%20d%27albigny%281%29.jpg",
        alt: "Cave à vins",
        caption: "Notre cave à vins",
        orientation: "square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/jks7fr4i_b%C3%A9a%20et%20thierry%20salle%20la%20table%20d%27albigny.jpg",
        full: "https://customer-assets.emergentagent.com/job_showcase-redesign-6/artifacts/jks7fr4i_b%C3%A9a%20et%20thierry%20salle%20la%20table%20d%27albigny.jpg",
        alt: "Béa et Thierry en salle",
        caption: "Béa & Thierry — vos hôtes",
        orientation: "square",
    },
    {
        src: "https://static.wixstatic.com/media/913191_b4068a14687948e6b6c5c5c566cd2e83~mv2.jpg/v1/fill/w_1600,h_1067,al_c,q_85,enc_avif,quality_auto/913191_b4068a14687948e6b6c5c5c566cd2e83~mv2.jpg",
        full: "https://static.wixstatic.com/media/913191_b4068a14687948e6b6c5c5c566cd2e83~mv2.jpg",
        alt: "Magret de canard fumé",
        caption: "Magret de canard fumé",
        orientation: "landscape",
    },
    {
        src: "https://static.wixstatic.com/media/913191_db810d189bb14577a6cc65569ed84baa~mv2.jpeg/v1/fill/w_1600,h_963,al_c,q_85,enc_avif,quality_auto/913191_db810d189bb14577a6cc65569ed84baa~mv2.jpeg",
        full: "https://static.wixstatic.com/media/913191_db810d189bb14577a6cc65569ed84baa~mv2.jpeg",
        alt: "La cuisine du restaurant",
        caption: "Invitation gourmande",
        orientation: "landscape",
    },
    {
        src: "https://static.wixstatic.com/media/913191_9303f6dc3ac04129a18c03c7cb6ce08b~mv2.jpg/v1/fill/w_960,h_1370,al_c,q_85,enc_avif,quality_auto/913191_9303f6dc3ac04129a18c03c7cb6ce08b~mv2.jpg",
        full: "https://static.wixstatic.com/media/913191_9303f6dc3ac04129a18c03c7cb6ce08b~mv2.jpg",
        alt: "Le chef Thierry Touvier",
        caption: "Au cœur de la cuisine",
        orientation: "portrait",
    },
];

export const Gallery = () => {
    const { gallery } = content;
    const [lightbox, setLightbox] = useState(null);

    const next = () => setLightbox((i) => (i + 1) % PHOTOS.length);
    const prev = () => setLightbox((i) => (i - 1 + PHOTOS.length) % PHOTOS.length);

    useEffect(() => {
        if (lightbox === null) return;
        const onKey = (e) => {
            if (e.key === "Escape") setLightbox(null);
            else if (e.key === "ArrowRight") next();
            else if (e.key === "ArrowLeft") prev();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [lightbox]);

    return (
        <section
            id="galerie"
            data-testid="gallery-section"
            className="relative bg-[#F1EBE1] pt-36 sm:pt-44 pb-24 sm:pb-36 px-6 sm:px-12 lg:px-24"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
                    <div className="lg:col-span-7 reveal">
                        <p className="text-[10px] sm:text-xs uppercase tracking-[0.4em] text-[#8B5A2B] font-bold mb-6">
                            {gallery.overline}
                        </p>
                        <h1
                            data-testid="gallery-title"
                            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2C1E16] leading-[1.05] text-balance"
                        >
                            {gallery.title}{" "}
                            <span className="italic text-[#8B5A2B]">{gallery.titleItalic}</span>
                        </h1>
                    </div>
                    <div className="lg:col-span-5 reveal">
                        <p className="text-[#5C4033] text-base sm:text-lg leading-relaxed">
                            {gallery.subtitle}
                        </p>
                    </div>
                </div>

                {/* Mosaïque CSS columns - layout style "masonry" */}
                <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 sm:gap-6 [column-fill:_balance]">
                    {PHOTOS.map((p, idx) => (
                        <button
                            key={idx}
                            type="button"
                            onClick={() => setLightbox(idx)}
                            data-testid={`gallery-photo-${idx}`}
                            className="mb-4 sm:mb-6 block w-full overflow-hidden group focus:outline-none focus:ring-2 focus:ring-[#5C4033] break-inside-avoid"
                            style={{ animationDelay: `${idx * 60}ms` }}
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={p.src}
                                    alt={p.alt}
                                    loading="lazy"
                                    className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-[1500ms]"
                                />
                                <div className="absolute inset-0 bg-[#2C1E16]/0 group-hover:bg-[#2C1E16]/15 transition-colors duration-500" />
                            </div>
                            <p className="mt-3 text-left text-xs uppercase tracking-[0.25em] text-[#8B5A2B]">
                                {p.caption}
                            </p>
                        </button>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightbox !== null && (
                <div
                    data-testid="gallery-lightbox"
                    className="fixed inset-0 z-[100] bg-[#2C1E16]/95 backdrop-blur-sm flex items-center justify-center p-6 sm:p-12 animate-fade-in"
                    onClick={() => setLightbox(null)}
                >
                    <button
                        type="button"
                        aria-label="Fermer"
                        data-testid="lightbox-close"
                        onClick={(e) => {
                            e.stopPropagation();
                            setLightbox(null);
                        }}
                        className="absolute top-6 right-6 text-white/80 hover:text-white p-2"
                    >
                        <X size={32} />
                    </button>
                    <button
                        type="button"
                        aria-label="Précédente"
                        onClick={(e) => {
                            e.stopPropagation();
                            prev();
                        }}
                        className="absolute left-3 sm:left-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white p-2"
                    >
                        <ChevronLeft size={40} />
                    </button>
                    <button
                        type="button"
                        aria-label="Suivante"
                        onClick={(e) => {
                            e.stopPropagation();
                            next();
                        }}
                        className="absolute right-3 sm:right-8 top-1/2 -translate-y-1/2 text-white/70 hover:text-white p-2"
                    >
                        <ChevronRight size={40} />
                    </button>
                    <figure className="max-w-[92vw] max-h-[88vh] flex flex-col items-center gap-4">
                        <img
                            src={PHOTOS[lightbox].full}
                            alt={PHOTOS[lightbox].alt}
                            className="max-h-[80vh] max-w-[92vw] object-contain shadow-2xl"
                            onClick={(e) => e.stopPropagation()}
                        />
                        <figcaption className="text-white/80 text-xs uppercase tracking-[0.25em]">
                            {PHOTOS[lightbox].caption}
                        </figcaption>
                    </figure>
                </div>
            )}
        </section>
    );
};
